// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import gitVersion from '../environments/git-version';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import V1 from './pages/v1';
import V2 from './pages/v2';
import V1Login from './pages/v1/login';
import V2Login from './pages/v2/login';
import V1Logout from './pages/v1/logout';
import V2Logout from './pages/v2/logout';
import Admin from './pages/admin';
import Roles from './pages/roles';
import Interview from './pages/interview';
import { RequireRole } from './components/RequireRole';

// Log SCM/build metadata on client startup
console.log(JSON.stringify(gitVersion));

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/app/v1" replace />} />
        <Route path="/app" element={<Navigate to="/app/v1" replace />} />
        <Route path="/app/v1" element={<V1 />} />
        <Route path="/app/v2" element={<V2 />} />
        <Route path="/app/v1/login" element={<V1Login />} />
        <Route path="/app/v2/login" element={<V2Login />} />
        <Route path="/app/v1/logout" element={<V1Logout />} />
        <Route path="/app/v2/logout" element={<V2Logout />} />
        <Route
          path="/app/v1/admin"
          element={
            <RequireRole authProvider="sso" redirectUri="/app/v1/admin" allowedRoles={['admin']}>
              {({ userEmail }) => <Admin userEmail={userEmail} />}
            </RequireRole>
          }
        />
        <Route
          path="/app/v2/admin"
          element={
            <RequireRole authProvider="login" redirectUri="/app/v2/admin" allowedRoles={['admin']}>
              {({ userEmail }) => <Admin userEmail={userEmail} />}
            </RequireRole>
          }
        />
        <Route
          path="/app/v1/roles"
          element={
            <RequireRole authProvider="sso" redirectUri="/app/v1/roles" allowedRoles={['admin']}>
              {({ userEmail }) => <Roles userEmail={userEmail} />}
            </RequireRole>
          }
        />
        <Route
          path="/app/v2/roles"
          element={
            <RequireRole authProvider="login" redirectUri="/app/v2/roles" allowedRoles={['admin']}>
              {({ userEmail }) => <Roles userEmail={userEmail} />}
            </RequireRole>
          }
        />
        <Route path="/app/v1/interview" element={<Interview />} />
        <Route path="/app/v2/interview" element={<Interview />} />
      </Routes>
    </div>
  </BrowserRouter>
);
